import styles from "./PhotographersGrid.module.css"
import db from "../prisma-db"

export default async function PhotographersGrid(){
    const photographers = db.getAllPhotographers;
}